import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Main from "./pages/main";
import StoryQuestion from "./pages/story/question";
import StoryRiskyPregnancy from "./pages/story/riskyPregnancy";
import Shopping from "./pages/shopping/shopping";
import StoryTimeLine from "./pages/story/timeLine";
import Authentication from "./pages/authentication/authentication";
import Mypage from "./pages/mypage/mypage";
import BabyInfo from "./pages/mypage/baby-info";
import MyInfo from "./pages/mypage/my-info";
import useAuthStore from "./store/authStore";
import StoryQuestionDetail from "./pages/story/questionDetail";
import StoryTimeLineDetail from "./pages/story/timeLineDetail";
import Toast from "./components/common/toast";
import KakaoCallback from "./pages/KakaoCallback";
import CardDetail from "./pages/card/detail";

const ProtectedRoute = ({ children, onShowToast }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (!isAuthenticated) {
    onShowToast("로그인이 필요한 페이지입니다.");
    return <Navigate to="/" replace />;
  }

  return children;
};

const App = () => {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const showToast = (message) => {
    setToastMessage(message);
    setToastOpen(true);
  };

  const closeToast = () => {
    setToastOpen(false);
  };

  // 실제 화면 높이 측정 및 CSS 변수 설정
  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVH();

    // 화면 크기 변경 시 재계산
    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);

    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVH();

    window.addEventListener("resize", setVH);
    window.addEventListener("orientationchange", setVH);

    return () => {
      window.removeEventListener("resize", setVH);
      window.removeEventListener("orientationchange", setVH);
    };
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "#f9fafb";

    document.body.style.overscrollBehavior = "none";

    document.documentElement.style.backgroundColor = "#f9fafb";

    return () => {
      document.body.style.backgroundColor = "";
      document.body.style.overscrollBehavior = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, []);

  return (
    <div
      className="bg-gray-50 relative"
      style={{
        minHeight: "calc(var(--vh, 1vh) * 100)",
        backgroundColor: "#f9fafb",
      }}
    >
      <div
        className="fixed inset-0 bg-white -z-10"
      />
      <div className="mx-auto block max-w-[900px] min-w-[360px] h-full">
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/main" />} />
            <Route path="/main" element={<Main />} />
            <Route path="/kakao/callback" element={<KakaoCallback />} />
            <Route path="/story" element={<Navigate to="/story/question" />} />
            <Route path="/story/question" element={<StoryQuestion />} />
            <Route
              path="/story/question/:id"
              element={<StoryQuestionDetail />}
            />
            <Route path="/story/timeline" element={<StoryTimeLine />} />
            <Route
              path="/story/timeline/:id"
              element={<StoryTimeLineDetail />}
            />
            <Route
              path="/story/riskypregnancy"
              element={<StoryRiskyPregnancy />}
            />
            <Route path="/shopping" element={<Shopping />} />
            <Route path="/card/detail" element={<CardDetail />} />
            <Route path="/mypage" element={<Mypage />} />
            <Route
              path="/mypage/baby-info"
              element={
                <ProtectedRoute onShowToast={showToast}>
                  <BabyInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mypage/my-info"
              element={
                <ProtectedRoute onShowToast={showToast}>
                  <MyInfo />
                </ProtectedRoute>
              }
            />

            <Route
              path="/authentication"
              element={
                <ProtectedRoute onShowToast={showToast}>
                  <Authentication />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </div>

      <Toast isOpen={toastOpen} message={toastMessage} onClose={closeToast} />
    </div>
  );
};

export default App;
